export default __webpack_public_path__ + "static/media/loop.6d763638.jpeg";